<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('home.messages.title') }}</h3>
        </div>

        <div class="text-center mb-5">
            <p>{{ $t('home.messages.setting') }}</p>
        </div>

        <div>
            <div class="show_ID">
                <p>{{ $t('account.edit.account') }} :
                    <span>{{email ? email : '-'}}</span>
                </p>
                <p>{{ $t('account.edit.accountId') }} :
                    <span>{{force_club_id ? force_club_id : '-'}}</span>
                </p>
            </div>

            <div v-if="kycSettings">
                <a href="/kyc-settings">
                    <div class="message-card" :class="[{ active: (! isLoaded()) ? true : isKycActive() }]">
                        <h4>{{ $t('kyc.message.title') }}</h4>
                        <span v-text="isLoaded() ? $t(`kyc.message.statuses[${kycStatus}]`) : $t('loading')"></span>
                    </div>
                </a>
            </div>
            <div v-if="!kycSettings">
                <div class="message-card" :class="[{ active: (! isLoaded()) ? true : isKycActive() }]">
                    <h4>{{ $t('kyc.message.title') }}</h4>
                    <span v-text="isLoaded() ? $t(`kyc.message.statuses[${kycStatus}]`) : $t('loading')"></span>
                </div>
            </div>

            <router-link to="/activation">
                <div class="message-card" :class="[{ active: (! isLoaded()) ? true : isForceClubActive() }]">
                    <h4 v-text="$t('force.messages.title')"></h4>
                    <span v-text="isLoaded() ? $t(`force.messages.statuses[${forceClubStatus}]`) : $t('loading')"></span>
                </div>
            </router-link>
            
            <!-- HEC Saving申し込み 状態：未完了-->
            <div v-if="(!isLoaded() || !this.is_hecsaving_applied)">
                <router-link :to="{ name: 'hecSavingApplication' }">
                    <div class="message-card active">
                        <h4 v-text="$t('hecSaving.messages.title')"></h4>
                        <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                        <span v-else>{{ $t(`hecSaving.messages.statuses[${hecSavingStatus}]`) }}</span>
                    </div>
                </router-link>
            </div>
            <!-- HEC Saving申し込み 状態：完了-->
            <div v-else-if="this.is_hecsaving_applied">
                <div class="message-card">
                    <h4 v-text="$t('hecSaving.messages.title')"></h4>
                    <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                    <span v-else>{{ $t(`hecSaving.messages.statuses[${hecSavingStatus}]`) }}</span>
                </div>
            </div>

            <div v-if="this.notForceClubMember">
                <!-- フォルスクラブ支払いステータスが未払いの場合-->
                <div v-if="(!this.is_hecsaving_applied && !this.latestMembershipFee)">
                    <!-- HEC Savingが未申込および契約データが存在しない場合-->
                    <div class="message-card message-card-disable">
                        <h4 v-text="$t('payment.messages.title')"></h4>
                        <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                        <span v-else>{{ $t(`payment.messages.statuses[${membershipFeeStatus}]`) }}</span>
                    </div>
                </div>
                
                <div v-if="(!this.is_hecsaving_applied 
                    && this.latestMembershipFee && this.latestMembershipFee.is_active)">
                    <!-- MembershipFeeテーブルに登録されて居る最新のデータが有効だった場合-->
                    <div class="message-card">
                        <h4 v-text="$t('payment.messages.title')"></h4>
                        <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                        <span v-else>{{ $t(`payment.messages.statuses[${membershipFeeStatus}]`) }}</span>
                    </div>
                </div>

                <div v-if="(!this.is_hecsaving_applied 
                    && this.latestMembershipFee && !this.latestMembershipFee.is_active)">
                    <!-- MembershipFeeテーブルに登録されて居る最新のデータが有効ではない場合-->
                    <div class="message-card message-card-disable">
                        <h4 v-text="$t('payment.messages.title')"></h4>
                        <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                        <span v-else>{{ $t(`payment.messages.statuses[${membershipFeeStatus}]`) }}</span>
                    </div>
                </div>

                <div v-if="(this.is_hecsaving_applied)">
                    <!-- HEC Savingが申込済の場合 -->
                    <div class="message-card message-card-disable">
                        <h4 v-text="$t('payment.messages.title')"></h4>
                        <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                        <span v-else>{{ $t(`payment.messages.statuses[${membershipFeeStatus}]`) }}</span>
                    </div>
                </div>
            </div>         
            <!-- ForceClubを退会、停止していない場合　-->
            <div v-if="!this.notForceClubMember">
                <!-- HEC Saving申込している場合-->
                <div v-if="this.is_hecsaving_applied">
                    <!-- フォルシング開始手続き画面(規約)へ遷移 -->
                    <!-- フォルシング契約の状態：未完了 -->
                    <div v-if="(!isLoaded() || !this.latestMembershipFee)">
                        <router-link :to="{ name: 'MembershipFeePolicy' }">
                            <div class="message-card active">
                                <h4 v-text="$t('payment.messages.title')"></h4>
                                <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                                <span v-else>{{ $t(`payment.messages.statuses[${membershipFeeStatus}]`) }}</span>
                            </div>
                        </router-link>
                    </div>
                    <!-- フォルシング開始手続き画面(HEC数)へ遷移 -->
                    <!-- フォルシング契約の状態：次回契約受付中 -->
                    <div v-else-if="(this.latestMembershipFee && !this.latestMembershipFee.is_active)">
                        <!-- メンバータイプ詳細：プレミアムメンバー、アップグレードしたプレミアムメンバー（初回払い出し日が契約終了日より前） -->
                        <!-- フォルシング更新可能フラグ：更新可能日を過ぎているので更新可能 -->
                        <div v-if="((this.membertypeDetail == 'PREMIUM_MEMBER' || 
                                    this.membertypeDetail == 'UPGRADE_PREMIUM_MEMBER_PAYOUT_BELOW_CONTRACT') &&
                                    this.forthingRenewalFlg)">
                            <router-link :to="{ name: 'MembershipFeeConditionRenewal' }">
                                <div class="message-card active">
                                    <h4 v-text="$t('payment.messages.title')"></h4>
                                    <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                                    <span v-else>{{ $t(`payment.messages.statuses[${membershipFeeStatus}]`) }}</span>
                                </div>
                            </router-link>
                        </div>
                        <!-- メンバータイプ詳細：プレミアムメンバー、アップグレードしたプレミアムメンバー（初回払い出し日が契約終了日より前） -->
                        <!-- フォルシング更新可能フラグ：更新可能日より前なので更新不可 -->
                        <div v-else-if="((this.membertypeDetail == 'PREMIUM_MEMBER' || 
                                    this.membertypeDetail ==='UPGRADE_PREMIUM_MEMBER_PAYOUT_BELOW_CONTRACT') &&
                                    !this.forthingRenewalFlg)">
                            <div class="message-card message-card-disable">
                                <h4 v-text="$t('payment.messages.title')"></h4>
                                <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                                <span v-else>{{ $t(`payment.messages.statuses[${membershipFeeStatus}]`) }}</span>
                            </div>
                        </div>
                        <!-- メンバータイプ詳細：サポートメンバー、アップグレードしたプレミアムメンバー（初回払い出し日が契約終了日以後） -->
                        <!-- フォルシング更新可能フラグ：更新可能日を過ぎているので更新可能 -->
                        <div v-else-if="((this.membertypeDetail == 'SUPPORT_MEMBER' || 
                                    this.membertypeDetail == 'UPGRADE_PREMIUM_MEMBER_PAYOUT_OR_OVER_CONTRACT') &&
                                    this.forthingRenewalFlg)">
                            <router-link :to="{ name: 'MembershipFeeConditionRenewal' }">
                                <div class="message-card active">
                                    <h4 v-text="$t('payment.messages.title')"></h4>
                                    <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                                    <span v-else>{{ $t(`payment.messages.statuses[${membershipFeeStatus}]`) }}</span>
                                </div>
                            </router-link>
                        </div>
                        <!-- メンバータイプ詳細：サポートメンバー、アップグレードしたプレミアムメンバー（初回払い出し日が契約終了日以後） -->
                        <!-- フォルシング更新可能フラグ：更新可能日より前なので更新不可 -->
                        <div v-else-if="((this.membertypeDetail == 'SUPPORT_MEMBER' || 
                                    this.membertypeDetail == 'UPGRADE_PREMIUM_MEMBER_PAYOUT_OR_OVER_CONTRACT') &&
                                    !this.forthingRenewalFlg)">
                            <div class="message-card message-card-disable">
                                <h4 v-text="$t('payment.messages.title')"></h4>
                                <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                                <span v-else>{{ $t(`payment.messages.statuses[${membershipFeeStatus}]`) }}</span>
                            </div>
                            <span class="warning">{{ $t(`payment.warning`) }}</span>
                        </div>
                    </div>
                    <!-- 遷移しない -->
                    <!-- フォルシング契約の状態：完了 -->
                    <div v-else-if="(this.latestMembershipFee && this.latestMembershipFee.is_active)">
                        <div class="message-card">
                            <h4 v-text="$t('payment.messages.title')"></h4>
                            <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                            <span v-else>{{ $t(`payment.messages.statuses[${membershipFeeStatus}]`) }}</span>
                        </div>
                    </div>
                    <!-- データ不整合 -->
                    <div v-else >
                        <div class="message-card message-card-disable">
                            <h4 v-text="$t('payment.messages.title')"></h4>
                            <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                            <span>{{ $t(`payment.messages.statuses[${membershipFeeHecStatus}]`) }}</span>
                        </div>
                    </div>
                </div>
                <!-- HEC Saving申込していない場合-->
                <div v-else-if="!this.is_hecsaving_applied">
                    <!-- 遷移しない -->
                    <!-- フォルシング契約の状態：未完了 -->
                    <!-- チェックアウト中でない -->
                    <div v-if="(!isLoaded() || !this.latestMembershipFee)">
                        <div class="message-card message-card-disable">
                            <h4 v-text="$t('payment.messages.title')"></h4>
                            <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                            <span v-else>{{ $t(`payment.messages.statuses[${membershipFeeHecStatus}]`) }}</span>
                        </div>
                    </div>
                    <!-- 遷移しない -->
                    <!-- フォルシング契約の状態：完了 -->
                    <!-- チェックアウト中でない -->
                    <div v-else-if="this.latestMembershipFee.is_active">
                        <div class="message-card">
                            <h4 v-text="$t('payment.messages.title')"></h4>
                            <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                            <span v-else>{{ $t(`payment.messages.statuses[${membershipFeeHecStatus}]`) }}</span>
                        </div>
                    </div>
                    <!-- 遷移しない -->
                    <!-- フォルシング契約の状態：次回契約受付中 -->
                    <!-- チェックアウト中でない -->
                    <div v-else-if="!this.latestMembershipFee.is_active">
                        <div class="message-card message-card-disable">
                            <h4 v-text="$t('payment.messages.title')"></h4>
                            <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                            <span v-else>{{ $t(`payment.messages.statuses[${membershipFeeHecStatus}]`) }}</span>
                        </div>
                    </div>
                    <!-- 遷移しない -->
                     <div v-else >
                        <div class="message-card message-card-disable">
                            <h4 v-text="$t('payment.messages.title')"></h4>
                            <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                            <span>{{ $t(`payment.messages.statuses[${membershipFeeHecStatus}]`) }}</span>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import userService from './../services/UserService';
    import kycService from './../services/KycService';
    import { KYC_SETTINGS_APPROVAL, STATUS_NOT_SET, STATUS_ACTIVE, STATUS_RENEWAL, STATUS_HYPHEN} from '../utils/Const';

    export default {
        components: {

        },
        data() {
            return {
                kycStatus: undefined,
                forceClubStatus: undefined,
                latestMembershipFee: undefined,
                email: undefined,
                force_club_id: undefined,
                ex_bonus_title: undefined,
                kycSettings: false,
                notForceClubMember: false,
                is_hecsaving_applied: false,
                membertypeDetail: undefined,
                forthingRenewalFlg: false,
            }
        },

        async created() {
        },

        async mounted() {
            this.fetchData();
        },

        methods: {
            isLoaded() {
                return (
                    this.kycStatus       !== undefined &&
                    this.forceClubStatus !== undefined &&
                    this.latestMembershipFee !== undefined 
                );
            },

            isKycActive() {
                return (
                    this.kycStatus === kycService.STATUSES.NOT_UPLOADED ||
                    this.kycStatus === kycService.STATUSES.REJECTED
                );
            },

            isForceClubActive() {
                return this.forceClubStatus === '0';
            },

            isPaymentActive() {
                if(! this.latestMembershipFee) return true;
                return this.latestMembershipFee.is_close_to_end;
            },

            getPaymentStatus() {
                if(! this.latestMembershipFee) return 0;
                if(! this.latestMembershipFee.is_close_to_end) return 1;
                return 2;
            },

            async fetchData() {
                const data = (await userService.getUserFrontendData(true)).data;
                const forceClubData = await userService.getForceClubInfoData(); //ForceClub退会、停止情報取得

                this.kycStatus = (data.kyc && data.kyc.status) ? data.kyc.status : '0';
                this.forceClubStatus = data.forceClub ? data.forceClub.status : '0';
                this.latestMembershipFee = data.latestMembershipFee; //フォルシング契約の状態
                this.email = data.email;
                this.force_club_id = data.force_club_id;
                this.ex_bonus_title = data.title;
                this.notForceClubMember = forceClubData.data; //ForceClub退会、停止の状態
                this.is_hecsaving_applied = data.is_hecsaving_applied; //HEC Saving申込状況
                this.membertypeDetail = data.membertypeDetail; //メンバータイプ詳細（プレミアム、サポート、アップグレードメンバー）
                var forthingRenewalDate = Date.parse(data.forthingRenewalDate); //契約更新可能日を日付型に変換
                var nowDate = new Date();//現在日時を取得
                // 現在日時が契約更新可能日を過ぎているか
                if(nowDate > forthingRenewalDate){
                    // 過ぎていれば更新可能フラグを立てる
                    this.forthingRenewalFlg = true;
                }else{
                    this.forthingRenewalFlg = false;
                }

                if (Number(this.kycStatus) !== KYC_SETTINGS_APPROVAL){
                    this.kycSettings = true
                }
            },
        },



        computed: {
            membershipFeeStatus: function () {
                //未完了
                if (!this.latestMembershipFee){
                    return STATUS_NOT_SET;
                }
                //完了
                if (this.latestMembershipFee && this.latestMembershipFee.is_active) {
                    return STATUS_ACTIVE;
                }
                // //次回契約受付中
                if (this.latestMembershipFee && !this.latestMembershipFee.is_active){
                    return STATUS_RENEWAL;
                }
                return STATUS_HYPHEN;
            },
            membershipFeeHecStatus: function () {
                //未完了
                if (!this.latestMembershipFee){
                    return STATUS_NOT_SET;   
                }
                //完了
                if (this.latestMembershipFee && this.latestMembershipFee.is_active) {
                    return STATUS_ACTIVE;
                }
                //次回契約受付中
                if (this.latestMembershipFee && !this.latestMembershipFee.is_active) {
                    return STATUS_RENEWAL;
                }
                return STATUS_HYPHEN;
            },
            hecSavingStatus: function (){
                if (!this.is_hecsaving_applied){
                    return STATUS_NOT_SET; //未完了
                } else {
                    return STATUS_ACTIVE;  //完了
                }
            }
        }
    }
</script>

<style scoped>
    .message-card {
        color: #fff;
        padding: 10px;
        text-align: center;
        margin: 0 auto 20px;
        background: #451493;
    }
    .message-card-disable {
        background-color: #c6c6c6 !important;;
    }
    .message-card-disable:hover {
        background-color: #c6c6c6 !important;;
    }
    .message-card:hover {
        background: #350f71;
    }
    .message-card.active{
        cursor: pointer;
        background: #EDE3E9;
        color: #2B2D42;
    }
    .message-card.active:hover{
        background: #e3c9d9;
    }
    .show_ID {
        margin: -10px 0px 40px 0px;
        font-size: 1.2em;
    }
    .warning{
        color:red;
    }
    @media screen and (max-width: 767px) {
        .show_ID span {
            font-weight: bold;
        }
    }
</style>
